export default {
  // Menus
  'menu.recommendations': 'Recommendations',
  'menu.gallery-detail-ads': 'Gallery Detail Ads',
  'site-setting': 'Site Settings',
  'site-setting.basic': 'Basic Settings',
  'site-setting.recommendations': 'Recommendations',
  'site-setting.gallery-detail-ads': 'Gallery Detail Ads',
  'frontend-users': 'Gallery Users',
  'user-posts': 'User Posts',
  'user-comments': 'User Comments',
  'admin-users': 'Admin Users',

  // Site settings
  'site.loadError': 'Failed to load site settings',
  'site.saveSuccess': 'Saved successfully',
  'site.saveError': 'Save failed',
  'site.title.label': 'Site Title',
  'site.title.required': 'Please enter the site title',
  'site.announcement.label': 'Announcement',
  'site.customerServiceLink.label': 'Customer Service Link',
  'site.customerServiceLink.required': 'Please enter the customer service link',
  'site.appIcon.label': 'App Icon',
  'site.bannerPics.label': 'Banner Images',
  'site.bannerPics.delete': 'Delete',
  'site.bannerPics.image': 'Image',
  'site.bannerPics.image.required': 'Please upload the banner image URL',
  'site.bannerPics.url': 'Link URL',

  // Recommendations
  'recommendations.tab.website': 'Website Recommendations',
  'recommendations.tab.guarantee': 'Guarantee Recommendations',
  'recommendations.loadError': 'Failed to load recommendations',
  'recommendations.saveSuccess': 'Saved successfully',
  'recommendations.saveError': 'Save failed',
  'recommendations.action.add': 'Add Recommendation',
  'recommendations.action.saveList': 'Save Recommendations',
  'recommendations.list.label': 'Domain Links',
  'recommendations.form.name': 'Domain',
  'recommendations.form.name.required': 'Please enter the domain',
  'recommendations.form.url': 'Link URL',
  'recommendations.form.url.required': 'Please enter a link URL',
  'recommendations.form.imageUrl': 'Image URL',
  'recommendations.form.imageUrl.required': 'Please enter an image URL',

  // Gallery detail ads
  'galleryAds.loadError': 'Failed to load gallery ads',
  'galleryAds.saveSuccess': 'Saved successfully',
  'galleryAds.saveError': 'Save failed',
  'galleryAds.brandName': 'Brand Name',
  'galleryAds.brandName.required': 'Please enter the brand name',
  'galleryAds.ctaUrl': 'Landing URL',
  'galleryAds.ctaUrl.required': 'Please enter the landing URL',
  'galleryAds.bbsName': 'Forum Name',
  'galleryAds.bbsName.required': 'Please enter the forum name',
  'galleryAds.bbsUrl': 'Forum URL',
  'galleryAds.bbsUrl.required': 'Please enter the forum URL',
  'galleryAds.bannerPics': 'Banner Images',
  'galleryAds.bannerPics.delete': 'Delete',
  'galleryAds.bannerPics.duplicate': 'Duplicate',
  'galleryAds.bannerPics.image': 'Image',
  'galleryAds.bannerPics.image.required': 'Please upload the image URL',
  'galleryAds.bannerPics.url': 'Link URL',
  'galleryAds.sites': 'Sites',
  'galleryAds.sites.delete': 'Delete',
  'galleryAds.sites.duplicate': 'Duplicate',
  'galleryAds.sites.name': 'Site Name',
  'galleryAds.sites.name.required': 'Please enter the site name',
  'galleryAds.sites.url': 'Site URL',
  'galleryAds.sites.url.required': 'Please enter the site URL',

  // Users
  'users.delete.success': 'User deleted successfully',
  'users.delete.error': 'Failed to delete user',
  'users.delete.admin.readonly': 'The admin account cannot be deleted',
  'users.reset.success': 'Password reset successfully',
  'users.reset.error': 'Failed to reset password',
  'users.create.success': 'User created successfully',
  'users.create.error': 'Failed to create user',
  'users.privileges.save.success': 'Privileges updated successfully',
  'users.privileges.save.error': 'Failed to update privileges',
  'users.privileges.admin.readonly': 'Privileges for the admin account cannot be modified',
  'users.columns.username': 'Username',
  'users.columns.twoFactorEnabled': '2FA',
  'users.2fa.action.generateQR': 'Generate QR',
  'users.2fa.action.unbind': 'Unbind',
  'users.2fa.modal.title': 'Set Up 2FA',
  'users.2fa.unbind.confirmTitle': 'Confirm Unbind 2FA',
  'users.2fa.unbind.confirmContent': 'Unbind 2FA for {name}?',
  'users.2fa.unbind.success': '2FA unbound successfully',
  'users.2fa.unbind.error': 'Failed to unbind 2FA',
  'users.columns.editSiteSetting': 'Site Settings',
  'users.columns.manageRecommendation': 'Recommendations',
  'users.columns.editGalleryDetailAds': 'Gallery Ads',
  'users.columns.manageFrontendUsers': 'Frontend Users',
  'users.columns.manageUserPosts': 'User Posts',
  'users.columns.manageUserComments': 'User Comments',
  'users.columns.actions': 'Actions',
  'users.actions.resetPassword': 'Reset Password',
  'users.actions.delete': 'Delete',
  'users.confirm.deleteTitle': 'Confirm delete user',
  'users.confirm.deleteContent': 'Delete user {name}?',
  'users.confirm.deleteNote': 'This action cannot be undone.',
  'users.modal.resetTitle': 'Reset User Password',
  'users.modal.resetForUser': 'Set a new password for {name}:',
  'users.modal.createTitle': 'Create New User',
  'users.modal.editPrivilegesTitle': 'Edit {name} permissions',
  'users.privileges.title': 'Privileges',
  'users.actions.savePrivileges': 'Save Privileges',
  'users.actions.cancel': 'Cancel',
  'users.form.username': 'Username',
  'users.form.username.placeholder': 'Enter username',
  'users.form.username.required': 'Please enter a username',
  'users.form.password': 'Password',
  'users.form.password.placeholder': 'Enter password',
  'users.form.password.required': 'Please enter a password',
  'users.form.password.min': 'Password must be at least 6 characters',
  'users.form.newPassword': 'New Password',
  'users.form.newPassword.placeholder': 'Enter new password',
  'users.form.newPassword.required': 'Please enter a new password',
  'users.form.newPassword.min': 'Password must be at least 6 characters',
  'users.form.confirmPassword': 'Confirm Password',
  'users.form.confirmPassword.placeholder': 'Confirm new password',
  'users.form.confirmPassword.required': 'Please confirm the new password',
  'users.privilege.editSiteSetting': 'Site Settings',
  'users.privilege.manageRecommendation': 'Recommendations',
  'users.privilege.editGalleryDetailAds': 'Gallery Ads',
  'users.privilege.manageFrontendUsers': 'Frontend Users',
  'users.privilege.manageUserPosts': 'User Posts',
  'users.privilege.manageUserComments': 'User Comments',

  // Frontend Users
  'feUsers.status.normal': 'Normal',
  'feUsers.status.blocked': 'Blocked',
  'feUsers.permission.enabled': 'Enabled',
  'feUsers.permission.disabled': 'Disabled',
  'feUsers.search.userId': 'User ID',
  'feUsers.columns.id': 'User ID',
  'feUsers.columns.username': 'Username',
  'feUsers.columns.nickname': 'Nickname',
  'feUsers.columns.avatar': 'Avatar URL',
  'feUsers.columns.email': 'Email',
  'feUsers.columns.mobile': 'Mobile',
  'feUsers.columns.accountStatus': 'Account Status',
  'feUsers.columns.postingPermission': 'Posting Permission',
  'feUsers.columns.commentingPermission': 'Commenting Permission',
  'feUsers.columns.invitationCode': 'Invitation Code',
  'feUsers.columns.lastLoginIpAddress': 'Last Login IP',
  'feUsers.columns.lastLoginAt': 'Last Login At',
  'feUsers.columns.registrationTime': 'Registration Time',
  'feUsers.columns.actions': 'Actions',
  'feUsers.actions.create': 'Create',
  'feUsers.actions.edit': 'Edit',
  'feUsers.actions.more': 'More',
  'feUsers.actions.setNormal': 'Set Normal',
  'feUsers.actions.setBlocked': 'Set Blocked',
  'feUsers.actions.block': 'Block Account',
  'feUsers.actions.enablePosting': 'Enable Posting',
  'feUsers.actions.disablePosting': 'Disable Posting',
  'feUsers.actions.enableCommenting': 'Enable Commenting',
  'feUsers.actions.disableCommenting': 'Disable Commenting',
  'feUsers.actions.resetPassword': 'Reset Password',
  'feUsers.actions.viewPosts': 'View Posts',
  'feUsers.actions.delete': 'Delete',
  'feUsers.actions.save': 'Save',
  'feUsers.actions.batchNormal': 'Batch Normal',
  'feUsers.actions.batchBlocked': 'Batch Blocked',
  'feUsers.actions.batchEnablePosting': 'Batch Enable Posting',
  'feUsers.actions.batchDisablePosting': 'Batch Disable Posting',
  'feUsers.actions.batchEnableCommenting': 'Batch Enable Commenting',
  'feUsers.actions.batchDisableCommenting': 'Batch Disable Commenting',
  'feUsers.drawer.createTitle': 'Create Frontend User',
  'feUsers.drawer.editTitle': 'Edit Frontend User',
  'feUsers.form.password': 'Password',
  'feUsers.form.password.required': 'Please enter a password',
  'feUsers.form.nickname': 'Nickname',
  'feUsers.form.avatar': 'Avatar URL',
  'feUsers.form.mobile': 'Mobile',
  'feUsers.form.mobile.required': 'Please enter a mobile number',
  'feUsers.form.lastLoginIpAddress': 'Last Login IP',
  'feUsers.form.postingPermission': 'Allow Posting',
  'feUsers.form.commentingPermission': 'Allow Commenting',
  'feUsers.messages.selectRequired': 'Please select users first',
  'feUsers.messages.createSuccess': 'Frontend user created successfully',
  'feUsers.messages.createError': 'Failed to create frontend user',
  'feUsers.messages.updateSuccess': 'Frontend user updated successfully',
  'feUsers.messages.updateError': 'Failed to update frontend user',
  'feUsers.messages.deleteSuccess': 'Frontend user deleted successfully',
  'feUsers.messages.deleteError': 'Failed to delete frontend user',
  'feUsers.messages.resetError': 'Failed to reset password',
  'feUsers.messages.statusSuccess': 'Account status updated successfully',
  'feUsers.messages.statusError': 'Failed to update account status',
  'feUsers.messages.blockSuccess': 'Account blocked successfully',
  'feUsers.messages.blockError': 'Failed to block account',
  'feUsers.messages.permissionSuccess': 'Permission updated successfully',
  'feUsers.messages.permissionError': 'Failed to update permission',
  'feUsers.messages.batchSuccess': 'Batch operation succeeded',
  'feUsers.messages.batchError': 'Batch operation failed',
  'feUsers.confirm.deleteTitle': 'Confirm delete user',
  'feUsers.confirm.deleteContent': 'Delete user {name}?',
  'feUsers.reset.confirmTitle': 'Confirm password reset',
  'feUsers.reset.confirmContent': 'Reset password for {name}?',
  'feUsers.reset.title': 'Password Reset Result',
  'feUsers.reset.description': 'Temporary password (copy immediately):',

  // Change password
  'password.mismatch': 'Passwords do not match',
  'password.change.success': 'Password updated successfully',
  'password.change.error': 'Failed to update password',
  'password.form.submit': 'Change Password',
  'password.form.new': 'New Password',
  'password.form.new.placeholder': 'Enter new password',
  'password.form.new.required': 'Please enter a new password',
  'password.form.new.min': 'Password must be at least 6 characters',
  'password.form.confirm': 'Confirm Password',
  'password.form.confirm.placeholder': 'Confirm new password',
  'password.form.confirm.required': 'Please confirm the new password',
  'password.form.confirm.min': 'Password must be at least 6 characters',

  // 2FA setup
  '2fa.error.generic': 'Error',
  '2fa.warning.enterCode': 'Please enter the code',
  '2fa.success.enable': 'Authenticator enabled successfully',
  '2fa.error.invalid': 'Invalid verification code',
  '2fa.page.title': 'Authenticator Setup',
  '2fa.bound': 'Authenticator already bound',
  '2fa.bind': 'Bind Authenticator',
  '2fa.scan': 'Scan QR Code',
  '2fa.verify': 'Verify',
  '2fa.input.placeholder': 'Enter 6-digit code',
  '2fa.button.verify': 'Verify and Bind',

  // Login
  'login.2fa.title': 'Two-Factor Verification',

  // Welcome page
  'welcome.title': 'Welcome to Tuku CMS',
  'welcome.desc': 'Follow the steps below to configure your site content.',
  'welcome.notice.deprecated':
    'Block/section/ad editing is temporarily offline until swagger APIs are ready.',
  'welcome.steps.siteSetting.title': 'Site Settings',
  'welcome.steps.siteSetting.desc':
    'Configure site title, announcement, customer service link, download icon, and banners.',
  'welcome.steps.recommendations.title': 'Recommendations',
  'welcome.steps.recommendations.desc':
    'Create and manage website/guarantee recommendation entries with links and images.',
  'welcome.steps.galleryAds.title': 'Gallery Detail Ads',
  'welcome.steps.galleryAds.desc':
    'Edit gallery page ads: brand info, landing URL, forum info, banners, and site list.',

  // Blocks
  'blocks.save.success': 'Saved successfully',
  'blocks.save.error': 'Save failed',
  'blocks.updatedAt': 'Updated at: {time} ({relative})',

  // Upload
  'upload.button': 'Upload',
  'upload.success': 'Image uploaded successfully',
  'upload.error': 'Failed to upload image',

  // Header
  'header.menu.changePassword': 'Change Password',
  'header.menu.setup2fa': 'Bind Authenticator',
  'header.menu.logout': 'Logout',
  'userPosts.search.authorId': 'Author ID',
  'userPosts.search.authorNickname': 'Author Nickname',
  'userPosts.columns.id': 'Post ID',
  'userPosts.columns.authorId': 'Author ID',
  'userPosts.columns.authorNickname': 'Author Nickname',
  'userPosts.columns.title': 'Title',
  'userPosts.columns.content': 'Content',
  'userPosts.columns.imageUrls': 'Images',
  'userPosts.columns.isFeatured': 'Featured',
  'userPosts.columns.approved': 'Approval',
  'userPosts.columns.createdAt': 'Created At',
  'userPosts.columns.updatedAt': 'Updated At',
  'userPosts.columns.actions': 'Actions',
  'userPosts.actions.approve': 'Approve',
  'userPosts.actions.disapprove': 'Disapprove',
  'userPosts.actions.batchApprove': 'Batch Approve',
  'userPosts.actions.batchDisapprove': 'Batch Disapprove',
  'userPosts.actions.edit': 'Edit',
  'userPosts.actions.delete': 'Delete',
  'userPosts.actions.save': 'Save',
  'userPosts.drawer.editTitle': 'Edit Post',
  'userPosts.form.title': 'Title',
  'userPosts.form.content': 'Content',
  'userPosts.form.imageUrls': 'Image URLs',
  'userPosts.form.imageUrls.help': 'Separate multiple URLs with commas',
  'userPosts.form.isFeatured': 'Featured',
  'userPosts.isFeatured.yes': 'Yes',
  'userPosts.isFeatured.no': 'No',
  'userPosts.approved.yes': 'Approved',
  'userPosts.approved.no': 'Unapproved',
  'userPosts.messages.updateSuccess': 'Post updated successfully',
  'userPosts.messages.updateError': 'Failed to update post',
  'userPosts.messages.deleteSuccess': 'Post deleted successfully',
  'userPosts.messages.deleteError': 'Failed to delete post',
  'userPosts.messages.approveSuccess': 'Post approved',
  'userPosts.messages.approveError': 'Failed to approve post',
  'userPosts.messages.disapproveSuccess': 'Post disapproved',
  'userPosts.messages.disapproveError': 'Failed to disapprove post',
  'userPosts.messages.batchApproveSuccess': 'Approved {count} posts',
  'userPosts.messages.batchApproveError': 'Failed to approve posts',
  'userPosts.messages.batchDisapproveSuccess': 'Disapproved {count} posts',
  'userPosts.messages.batchDisapproveError': 'Failed to disapprove posts',
  'userPosts.messages.batchSkipped': 'Skipped {count} posts',
  'userPosts.confirm.deleteTitle': 'Confirm delete post',
  'userPosts.confirm.deleteContent': 'Delete post {id}?',
  'userPosts.confirm.approveTitle': 'Confirm approve post',
  'userPosts.confirm.approveContent': 'Approve post {id}?',
  'userPosts.confirm.disapproveTitle': 'Confirm disapprove post',
  'userPosts.confirm.disapproveContent': 'Disapprove post {id}?',
  'userPosts.confirm.batchApproveTitle': 'Confirm batch approve',
  'userPosts.confirm.batchApproveContent': 'Approve {count} selected posts?',
  'userPosts.confirm.batchDisapproveTitle': 'Confirm batch disapprove',
  'userPosts.confirm.batchDisapproveContent': 'Disapprove {count} selected posts?',

  // User comments
  'userComments.search.authorId': 'Author ID',
  'userComments.search.authorNickname': 'Author Nickname',
  'userComments.search.parentCommentId': 'Parent Comment ID',
  'userComments.columns.id': 'Comment ID',
  'userComments.columns.authorId': 'Author ID',
  'userComments.columns.authorNickname': 'Author Nickname',
  'userComments.columns.postId': 'Post ID',
  'userComments.columns.content': 'Content',
  'userComments.columns.approved': 'Approval',
  'userComments.columns.createdAt': 'Created At',
  'userComments.columns.updatedAt': 'Updated At',
  'userComments.columns.actions': 'Actions',
  'userComments.actions.approve': 'Approve',
  'userComments.actions.disapprove': 'Disapprove',
  'userComments.actions.batchApprove': 'Batch Approve',
  'userComments.actions.batchDisapprove': 'Batch Disapprove',
  'userComments.actions.edit': 'Edit',
  'userComments.actions.delete': 'Delete',
  'userComments.actions.save': 'Save',
  'userComments.drawer.editTitle': 'Edit Comment',
  'userComments.form.content': 'Content',
  'userComments.approved.yes': 'Approved',
  'userComments.approved.no': 'Unapproved',
  'userComments.messages.updateSuccess': 'Comment updated successfully',
  'userComments.messages.updateError': 'Failed to update comment',
  'userComments.messages.deleteSuccess': 'Comment deleted successfully',
  'userComments.messages.deleteError': 'Failed to delete comment',
  'userComments.messages.approveSuccess': 'Comment approved',
  'userComments.messages.approveError': 'Failed to approve comment',
  'userComments.messages.disapproveSuccess': 'Comment disapproved',
  'userComments.messages.disapproveError': 'Failed to disapprove comment',
  'userComments.messages.batchApproveSuccess': 'Approved {count} comments',
  'userComments.messages.batchApproveError': 'Failed to approve comments',
  'userComments.messages.batchDisapproveSuccess': 'Disapproved {count} comments',
  'userComments.messages.batchDisapproveError': 'Failed to disapprove comments',
  'userComments.messages.batchSkipped': 'Skipped {count} comments',
  'userComments.confirm.deleteTitle': 'Confirm delete comment',
  'userComments.confirm.deleteContent': 'Delete comment {id}?',
  'userComments.confirm.approveTitle': 'Confirm approve comment',
  'userComments.confirm.approveContent': 'Approve comment {id}?',
  'userComments.confirm.disapproveTitle': 'Confirm disapprove comment',
  'userComments.confirm.disapproveContent': 'Disapprove comment {id}?',
  'userComments.confirm.batchApproveTitle': 'Confirm batch approve',
  'userComments.confirm.batchApproveContent': 'Approve {count} selected comments?',
  'userComments.confirm.batchDisapproveTitle': 'Confirm batch disapprove',
  'userComments.confirm.batchDisapproveContent': 'Disapprove {count} selected comments?',

  // Lottery Draw Records
  'lotteryRecords.search.lotteryType': 'Lottery Type',
  'lotteryRecords.search.issue': 'Issue',
  'lotteryRecords.columns.issue': 'Issue',
  'lotteryRecords.columns.gameDay': 'Game Day',
  'lotteryRecords.columns.openTime': 'Open Time',
  'lotteryRecords.columns.numbers': 'Numbers',
  'lotteryRecords.columns.sum': 'Sum',
  'lotteryRecords.columns.zodiacs': 'Zodiacs',
  'lotteryRecords.columns.colors': 'Colors',
  'lotteryRecords.columns.elements': 'Elements',
  'lotteryRecords.columns.bigSmall': 'Big/Small',
  'lotteryRecords.columns.oddEven': 'Odd/Even',
  'lotteryRecords.actions.create': 'New Draw Record',
  'lotteryRecords.modal.createTitle': 'New Draw Record',
  'lotteryRecords.form.lotteryType': 'Lottery Type',
  'lotteryRecords.form.lotteryType.required': 'Please select lottery type',
  'lotteryRecords.form.issue': 'Issue Sequence',
  'lotteryRecords.form.issue.required': 'Please enter 3-digit issue sequence',
  'lotteryRecords.form.issue.placeholder': 'e.g. 036',
  'lotteryRecords.form.numbers': 'Draw Numbers',
  'lotteryRecords.form.numbers.required': 'Please enter 7 draw numbers',
  'lotteryRecords.form.numbers.placeholder': 'Comma-separated 7 numbers, e.g. 36,26,37,02,44,31,28',
  'lotteryRecords.form.numbers.invalid': 'Please enter 7 valid numbers, each in range 1–49',
  'lotteryRecords.messages.createSuccess': 'Draw record created successfully',
  'lotteryRecords.messages.createError': 'Failed to create, please try again',
  'lotteryRecords.messages.createConflict': 'A draw record for this issue already exists',
  'lotteryRecords.form.gameDay': 'Game Day',
  'lotteryRecords.form.gameDay.placeholder': 'e.g. 20260307',
  'lotteryRecords.columns.actions': 'Actions',
  'lotteryRecords.actions.delete': 'Delete',
  'lotteryRecords.confirm.deleteTitle': 'Confirm delete draw record',
  'lotteryRecords.confirm.deleteContent': 'Delete draw record for issue {issue}? This cannot be undone.',
  'lotteryRecords.messages.deleteSuccess': 'Draw record deleted',
  'lotteryRecords.messages.deleteError': 'Failed to delete, please try again',
};
